// extracted by mini-css-extract-plugin
export default {"wrapper":"EnterYourDataScreen_wrapper__G5Twk","infoBlock":"EnterYourDataScreen_infoBlock__EDZhJ"};